import React from 'react';
export function Stats() {
  const stats = [{
    number: '500+',
    label: 'GRILLS SAVED'
  }, {
    number: '4.9★',
    label: 'AVG RATING'
  }, {
    number: '24HR',
    label: 'BOOKING'
  }, {
    number: '100%',
    label: 'SATISFACTION'
  }];
  return <section className="relative border-b-8 border-otter-black bg-otter-cyan py-16" data-id="element-291">
      <div className="absolute inset-0 bg-halftone bg-halftone-size opacity-20" data-id="element-292" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-293">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-4" data-id="element-294">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-295">
              <span className="font-display text-5xl tracking-tighter text-otter-black sm:text-6xl md:text-7xl" data-id="element-296">
                {stat.number}
              </span>
              <span className="mt-2 font-display text-xl tracking-wider text-otter-black/80" data-id="element-297">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}